import * as React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./select";

// A drop-in replacement for a native <select>.
//
//   <AppSelect value={v} onChange={(e) => setV(e.target.value)}
//              options={[{ value: 'all', label: 'Any type' }, ...]} />
//
// onChange receives { target: { value } } so existing handlers written for
// a native select keep working unchanged. An option whose value is '' is
// treated as the placeholder (shown when nothing is chosen) because the
// underlying menu cannot represent an empty value as a selectable item.
//
// variant: 'chip' (compact toolbar filter) or 'field' (full-width form input).

const AppSelect = React.forwardRef(
  (
    { value, onChange, options = [], placeholder, variant = "chip", className = "", id, disabled, ...rest },
    ref,
  ) => {
    const placeholderOption = options.find((o) => String(o.value) === "");
    const items = options.filter((o) => String(o.value) !== "");
    const current = value === undefined || value === null || String(value) === "" ? undefined : String(value);
    const hint = placeholder || placeholderOption?.label || "Select";

    return (
      <Select
        value={current}
        onValueChange={(next) => onChange?.({ target: { value: next } })}
        disabled={disabled}
      >
        <SelectTrigger
          ref={ref}
          id={id}
          className={`app-select app-select-${variant} ${className}`}
          {...rest}
        >
          <SelectValue placeholder={hint} />
        </SelectTrigger>
        <SelectContent>
          {items.map((o) => (
            <SelectItem key={String(o.value)} value={String(o.value)} disabled={o.disabled}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  },
);
AppSelect.displayName = "AppSelect";

export default AppSelect;
